import Sidebar from './components/layout/Sidebar'
import Header from './components/layout/Header'
import Dashboard from './pages/Dashboard'
import Canvas from './pages/Canvas'
import CharacterManager from './pages/CharacterManager'
import ClipLibrary from './pages/ClipLibrary'
import ImageLibrary from './pages/ImageLibrary'
import StoryboardBuilder from './pages/StoryboardBuilder'
import Settings from './pages/Settings'
import QuickImageGenerator from './pages/QuickImageGenerator'
import QuickVideoGenerator from './pages/QuickVideoGenerator'
import useStore from './store/useStore'

const PAGES = {
  'dashboard':         Dashboard,
  'quick-image':       QuickImageGenerator,
  'quick-video':       QuickVideoGenerator,
  'canvas':            Canvas,
  'character-manager': CharacterManager,
  'storyboard':        StoryboardBuilder,
  'clip-library':      ClipLibrary,
  'image-library':     ImageLibrary,
  'settings':          Settings,
}

export default function App() {
  const { currentPage } = useStore()
  const PageComponent = PAGES[currentPage] || Dashboard

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-surface">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Header />
        <main className="flex-1 overflow-hidden flex flex-col">
          <PageComponent />
        </main>
      </div>
    </div>
  )
}
